import React, { useState, useEffect } from "react";
import "./WhatWeBuild.scss";
// src/config/firebaseAssets.js

// Base path for your Firebase Storage files
export const FIREBASE_BASE_URL =
    "https://firebasestorage.googleapis.com/v0/b/techadive-safiriway.firebasestorage.app/o/techadive%2F";

// Helper to create image URLs
export const firebaseImage = (path, token) =>
    `${FIREBASE_BASE_URL}${path}?alt=media&token=${token}`;

// --- WHAT WE BUILD ---
export const webImage = firebaseImage(
    "whatwebuild%2Fweb.webp",
    "675f8b1f-087b-4392-8058-16c8411f04f9"
);

export const appImage = firebaseImage(
    "whatwebuild%2FmobileApp.webp",
    "e3899f84-ad7f-430b-9fdd-806ed12439bd"
);

export const tvImage = firebaseImage(
    "whatwebuild%2FtvImage.webp",
    "03b4f252-0a80-4b2c-acdc-2b17bc458765"
);

export const iotImage = firebaseImage(
    "whatwebuild%2Fiot.webp",
    "3a99eabe-9736-4119-b63f-48a1d6f5a1d9"
);

const WhatWeBuild = () => {
    const [activeCard, setActiveCard] = useState(null);

    const services = [
        {
            title: "Web Applications",
            desc: "We build modern, responsive, and fast-performing websites with cutting-edge technologies.",
            image: webImage,
        },
        {
            title: "Mobile Applications",
            desc: "Native and cross-platform mobile apps with sleek interfaces and great user experiences.",
            image: appImage,
        },
        {
            title: "Smart TV Applications",
            desc: "High-performance Smart TV and OTT applications for platforms like Android TV, Tizen, and webOS.",
            image: tvImage,
        },
        {
            title: "IoT Solutions",
            desc: "Smart, connected systems that integrate devices, sensors, and cloud platforms for real-time insights and control.",
            image: iotImage,
        },
    ];

    // Close active card when clicking outside
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (!e.target.closest(".card")) setActiveCard(null);
        };
        document.addEventListener("click", handleClickOutside);
        return () => document.removeEventListener("click", handleClickOutside);
    }, []);

    const handleCardClick = (index) => {
        if (window.matchMedia("(hover: none)").matches) {
            setActiveCard(activeCard === index ? null : index);
        }
    };

    return (
        <section className="what-we-build" id="what-we-build">
            <h2>What we build</h2>
            <p>We design and build digital and hardware solutions that bridge creativity and engineering. From modern web platforms to intelligent embedded systems, we turn complex challenges into simple, high-performing products.</p>

            <div className="cards">
                {services.map((s, i) => (
                    <ImageCard
                        key={i}
                        title={s.title}
                        desc={s.desc}
                        image={s.image}
                        active={activeCard === i}
                        onClick={() => handleCardClick(i)}
                        cardClass={`card-${i + 1}`}
                    />
                ))}
            </div>
        </section>
    );
};

const ImageCard = ({ title, desc, image, onClick, active, cardClass }) => {
    const [loaded, setLoaded] = useState(false);

    return (
        <div
            className={`card ${cardClass} ${active ? "active" : ""}`}
            onClick={onClick}
        >
            {!loaded && <div className="skeleton" />} {/* Skeleton placeholder */}
            <img
                src={image}
                alt={title}
                className={loaded ? "fade-in" : ""}
                style={{ display: loaded ? "block" : "none" }}
                onLoad={() => setLoaded(true)}
                onError={() => setLoaded(true)}
            />
            <div className="gradient-overlay" />
            <div className="card-content">
                <h3>{title}</h3>
                <div className="divider"></div>
                <p>{desc}</p>
            </div>
        </div>
    );
};

export default WhatWeBuild;
